module.exports = __webpack_public_path__ + "img/idCard.0aedd271.png";